<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { BFormGroup } from 'bootstrap-vue-next';
  import SuggestionBox from './SuggestionBox.vue';
  import CriteriaCard from './CriteriaCard.vue';

  const { t } = useI18n();

  const props = defineProps({
    object_type: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: false,
      default: []
    },
    // Classification scheme to suggest, the library's one by default
    scheme: {
      type: String,
      required: false,
      default: ''
    },
    // Displayed as a card highlighted when it has values, with a button to clear them
    card: {
      type: Boolean,
      required: false,
      default: false
    }
  });

  const inclusions = defineModel('inclusions');
  const exclusions = defineModel('exclusions');

  const clear = () => {
    inclusions.value = [];
    exclusions.value = [];
  };

  const label = computed(() => t(`advanced_search.${props.object_type}.label`));

  // A card is labelled by its own header, a fieldset by its legend
  const wrapper = computed(() => {
    if (!props.card) return { component: 'fieldset', attributes: { class: 'mt-3' } };

    return {
      component: CriteriaCard,
      attributes: { id: props.object_type, title: label.value, active: inclusions.value.length > 0 || exclusions.value.length > 0, onClear: clear }
    };
  });
</script>

<template>
  <component :is="wrapper.component" v-bind="wrapper.attributes">
    <legend v-if="!props.card" class="form-label fs-6">{{ label }}</legend>
    <div class="row">
      <div class="col-6">
        <label :for="`${props.object_type}_include`" class="form-label">{{ t('advanced_search.include') }}</label>
        <SuggestionBox v-model="inclusions" :object_type="props.object_type" :scheme="props.scheme" :inclusion="'include'" :options="props.options" />
      </div>
      <div class="col-6">
        <label :for="`${props.object_type}_exclude`" class="form-label">{{ t('advanced_search.exclude') }}</label>
        <SuggestionBox v-model="exclusions" :object_type="props.object_type" :scheme="props.scheme" :inclusion="'exclude'" :options="props.options" />
      </div>
    </div>
  </component>
</template>

<style scoped lang="scss">
  :deep() {
    @import '../../../../node_modules/bootstrap/scss/bootstrap.scss';
    @import '../../../../node_modules/bootstrap-vue-next/dist/bootstrap-vue-next';
  }
</style>

<i18n src="../../locales/en.json" global></i18n>
<i18n src="../../locales/fr.json" global></i18n>
<i18n src="../../locales/es.json" global></i18n>
<i18n src="../../locales/it.json" global></i18n>
<i18n src="../../locales/pt.json" global></i18n>
